<template>
  <div
    class="flex w-[327px] flex-col items-center justify-center font-proxima-nova 3xs:w-[366px] 2xs:w-[400px] xs:w-[496px]"
    :style="maxPopupElementSize"
  >
    <ui-m511-popup v-if="singleHazard" />
    <ui-map-incident-popup v-else-if="hazardType === HazardType.Incident" />
    <ui-map-warnings-popup v-else :event-id="eventId" :hazard-id="hazardId" :hazard-type="hazardType" />
  </div>
</template>

<script setup lang="ts">
import { EventEntity, HazardType, useHazardsStore, useMapStore } from '@/features/hazards';
import { LngLatLike } from 'mapbox-gl';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

const props = defineProps<{
  hazardType: HazardType;
  hazardId: string;
  eventId: string;
  coordinates: LngLatLike;
}>();

const mapStore = useMapStore();
const hazardsStore = useHazardsStore();

const { mapElementSize } = storeToRefs(mapStore);

const maxPopupElementSize = computed(() => {
  return {
    'max-height': mapElementSize.value.height - 48 + 'px',
  };
});

const relatedEvent = computed<EventEntity | undefined>(() => hazardsStore.hazards.events.find((event) => event.id === props.eventId));

/// The check on the `event-note` is to determine if the event has multiple hazards or is a single hazard event.
// TODO: This is quite brittle, a better approach is to enrich this on the hazard API response.
const singleHazard = computed<boolean>(() => !!relatedEvent.value && !relatedEvent.value?.rawEvent['event-note']);
</script>
